import { WebProduct } from '../../../../../types/web/WebProduct'
import { docs } from '../../../../../utils/consts'
import { formatCentsAmount } from '../../../../../utils/formatCentsAmount'
import Button from '../../../../Button'
import ExternalLink from '../../../../ExternalLink'
import Svg from '../../../../Svg'
import alternativeSectionSvg from '../svgs/alternative/section.svg'
import dentalSectionSvg from '../svgs/dental/section.svg'
import generalCareSectionSvg from '../svgs/generalCare/section.svg'

type Props = {
  onNextButtonClick: () => void
  productWeb: WebProduct
}

export function WebStep01IndexProductDetails(props: Props) {
  return (
    <div className="bg-white flex flex-col gap-4 text-xs">
      <div className="bg-greyLight p-4">
        <div className="flex flex-row justify-center">
          <DetailsCareIcon title="Médecine de ville" icon={generalCareSectionSvg} />
          <DetailsCareIcon title="Médecine douce" icon={alternativeSectionSvg} />
          {props.productWeb.isDentalCare && <DetailsCareIcon title="Soins dentaires" icon={dentalSectionSvg} />}
        </div>
      </div>

      <div className="px-4">
        <span className="font-bold">{props.productWeb.label}</span> vous permet d&apos;obtenir un complément de
        remboursement en{' '}
        <span className="font-bold">réduisant votre reste à charge de {props.productWeb.careValue}%</span> sur tous vos
        soins compris dans la formule, dans la limite de {formatCentsAmount(props.productWeb.limits.act)}&euro; de
        remboursement par catégorie et par an, soit un total de {formatCentsAmount(props.productWeb.limits.yearly)}
        &euro;
      </div>

      <Svg
        className="px-4 w-full"
        alt="exemple"
        height={30}
        src={props.productWeb.exemple.src}
        width={props.productWeb.exemple.width}
      />

      <div className="px-4 italic text-[10px] font-light text-center">
        *&nbsp;Montant variable en fonction de votre contrat de mutuelle.
      </div>
      <div className="px-4 text-center">
        Pour en savoir plus,{' '}
        <span className="font-bold underline">
          <ExternalLink href={docs.productsInformation(props.productWeb)}>téléchargez la documentation </ExternalLink>
        </span>
      </div>

      <div className="text-center">
        <Button small={true} onClick={props.onNextButtonClick} text="Souscrire" color={props.productWeb.color} />
      </div>
    </div>
  )
}

const DetailsCareIcon = (props: { icon: string; title: string }) => {
  return (
    <div className="flex items-center px-1">
      <div className="min-w-8">
        <Svg alt={props.title} height={50} src={props.icon} width={50} />
      </div>
      <div className="pl-2">
        <div className="text-[11px] leading-3 font-medium">{props.title}</div>
      </div>
    </div>
  )
}
